import { Chapter } from '@/types/types';
import { PlayIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { useMissionDetailingStore } from '../../store/useMissionDetailingStore';
import Button from '@/components/Button';
import ChapterCard from '@/components/Card/Chapter';
import { Maybe, Trait } from '@edwin-group/cj-graphql';

export const Card = ({
  chapter,
  trait,
  missionSlug,
  index,
  totalChapters,
  chapterId,
}: {
  chapter: Chapter;
  trait?: Maybe<Trait> | undefined;
  missionSlug: string;
  index: number;
  totalChapters: number;
  chapterId: string;
}) => {
  const navigate = useNavigate();
  const missionPage = useMissionDetailingStore((state) => state.missionPage);

  const onPressPlay = () => {
    if (chapter) {
      const encodedTitle = encodeURIComponent(chapter?.title || '');
      navigate(`/mission/${missionSlug}/chapter/${encodedTitle}`);
    }
  };

  return (
    <ChapterCard
      chapterId={chapterId}
      index={index}
      trait={trait}
      totalChapters={totalChapters}
      chapter={chapter}
      button={
        <Button onClick={onPressPlay} theme={'solid-primary-600'} size="default" className="self-start">
          <PlayIcon className=" h-5 w-5 !text-secondary-700" />
          {missionPage?.startButton}
        </Button>
      }
    />
  );
};
